module.exports = __webpack_public_path__ + "static/media/HCMM885.ad809614.jpg";